module.exports = __webpack_public_path__ + "print-4811f6f1b2da6b1618e1c831c3110472.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/social-medias/print.svg
// module id = 96
// module chunks = 0